module.exports = __webpack_public_path__ + "static/img/部件组成1-方向盘.12fab2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-1/部件组成1-方向盘.png
// module id = Y+A3
// module chunks = 0